import { render, staticRenderFns } from "./HelpVideo.vue?vue&type=template&id=087e2abf&"
import script from "./HelpVideo.vue?vue&type=script&lang=js&"
export * from "./HelpVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports